export const getParamsFromUrlInternal = ( queryString ) => {
  const urlParams = new URLSearchParams(queryString);
  const pdfKitUrl = getPDFKitUrl(urlParams.get('pdfKitUrl'));
  const ticket = urlParams.get('ticket');
  const locale = urlParams.get('locale');
  const maintenance = urlParams.get('maintenance');
  const status = urlParams.get('status');
  const standalone = urlParams.get('standalone') === 'true';

  return {
    pdfKitUrl,
    ticket,
    locale,
    maintenance,
    status,
    standalone
  };
};

export const getParamsFromUrl = () => {
  return getParamsFromUrlInternal(window.location.search);
};

export const getPDFKitUrl = ( urlFromParams ) => {
  if ( !urlFromParams ) {
    return window.location.protocol + '//' + window.location.host;
  } else {
    if (urlFromParams.endsWith('.bb-foundations.com')    // dev and TP
        || urlFromParams.endsWith('.blackboard.com')
        || urlFromParams.endsWith('.bb-dsg.com')
        || urlFromParams.endsWith('.bb-dsg-govcloud.com')) {
      return urlFromParams;
    } else {
      throw new Error('Document URL is not from a supported domain');
    }
  }
};

export const ticketExchange = async ( ticket ) => {
  const response = await fetch( '/api/v1/pdfviewer/tickets', {
    method: 'post',
    mode: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ticket
    })
  });
  if (response.ok) {
    return response;
  }
  throw new Error('Ticket is not valid');
};